import React from 'react';

import styles from './TextList.styles.js';

const TextList = ({ title, text, children }) => (
  <div css={styles}>
    <p className="text-list-title">{title}</p>
    <ul className="text-list-container">
      {text.map((t) => (
        <li className="text-list-points" dangerouslySetInnerHTML={{ __html: t || children }} key={t} />
      ))}
    </ul>
  </div>
);

export default TextList;
